export default "__VITE_ASSET__pL$m$3Lc__"